import { API_URL } from "../../config";

export const getAvatarUrl = username => {
  const randomString = Math.ceil(new Date().getTime() / 60000).toString();
  return `${API_URL}user/avatar/${username}?timestamp=${randomString}`;
};
